import { computed, ref, watch } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { INBOX_TYPES } from 'dashboard/helper/inbox';

export function useWhatsappInbox() {
  const inboxes = useMapGetter('inboxes/getInboxes');

  const whatsappInboxes = computed(() =>
    inboxes.value.filter(
      inbox =>
        inbox.channel_type === INBOX_TYPES.WHATSAPP &&
        inbox.provider === 'whatsapp_cloud'
    )
  );

  const selectedInboxId = ref(whatsappInboxes.value[0]?.id ?? null);

  // Auto-select the first inbox once the list resolves.
  watch(whatsappInboxes, list => {
    if (!selectedInboxId.value && list.length) {
      selectedInboxId.value = list[0].id;
    }
  });

  const hasWhatsappInbox = computed(() => whatsappInboxes.value.length > 0);

  return { whatsappInboxes, selectedInboxId, hasWhatsappInbox };
}
